import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './LeaveApprovalList.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { toWords } from 'number-to-words';
import fgIdentitySolutions from '../../../assets/Images/fgIdentitySolutions.jpg';

import { getDistrict, getProject, getStates, getLeavesEmployees, getClients } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const LeaveApprovalList = () => {
    const [state, setState] = useState(null);
    const [district, setDistrict] = useState(null);
    const [designation, setDesignation] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [employee, setEmployee] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const dateInputRef = useRef(null);
    const [toDate, setToDate] = useState("");
    const effectRan = useRef(false);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(null);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        designation: false,
        fromDate: false,
        employee: false,
        toDate: false,
        clients: false,
        project: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && clients && project && fromDate && toDate;


    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            // if (!effectRan.current) {
            fetchDistricts();
            // }
            // return () => {
            //     effectRan.current = true;
            // }

        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    const data = await getClients(state);
                    setClientResponse(
                        data.map(client => ({
                            value: client.id,
                            label: client.clientName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching clients:', error);
                    setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
                }
            };
            fetchClients();
        } else {
            setClientResponse([]);
            setClients(null);



        }
    }, [state]);
    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);

    // Fetch employees when district changes
    useEffect(() => {
        if (state, district) {
            const fetchEmployee = async () => {
                try {
                    const response = await getLeavesEmployees(state, district);
                    setEmployeeOptions(
                        response.map(emp => ({
                            value: emp.employeeUniqueId,
                            label: emp.employeeName,
                            designation: emp.designation,
                            employeeId: emp.employeeId
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching employees:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load employees' }));
                }
            };
            fetchEmployee();
        } else {
            setEmployeeOptions([]);
            setEmployee(null);
        }
    }, [state, district]);

    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, designation, year, employee]); // ✅ Add employee to depende

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);

                setClients(null);
                setProject(null); // ✅ Clear project when state changes

                break;
            case 'district':
                setDistrict(value);
                // setProject(null); // ✅ Clear project when district changes
                break;
            case 'designation':
                setDesignation(value);
                break;
            case 'employee':
                setEmployee(value); // now numeric employeeUniqueId

                if (selectedOption) {
                    const emp = employeeOptions.find(emp => emp.value === selectedOption.value);
                    setDesignation(emp ? emp.designation : '');
                } else {
                    setDesignation('');
                }
                break;


            case 'clients':
                setClients(value);
                setProject(null);
                break;

            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };




    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!clients) newErrors.designation = 'Month is required';
        if (!project) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFetchReport = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/leaves/reports`,
                {
                    params: {
                        stateId: state,
                        districtId: district,
                        employeeUniqueId: employee,
                        clientId: clients,
                        projectId: project,
                        startDate: fromDate,
                        endDate: toDate,
                    },
                }
            );

            // Some APIs return { employeeWiseReport: [...] }, some just return [...]
            const employeeData = Array.isArray(response.data)
                ? response.data
                : response.data.employeeWiseReport || [];

            const initializedData = employeeData.map((item) => ({
                ...item,
                casualLeave: item.casualLeave || 0,
                absentDays: item.absentDays || 0,
            }));

            setAttendanceData(initializedData);
        } catch (error) {
            console.error("Error fetching report data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch report data",
            }));
            alert("Failed to fetch report data. Please try again.");
        }
    };


    return (
        <div className="leave-approval-container">
            <div className="leave-approval-box">
                <h2 className="leave-approval-heading">Leave Report</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleFetchReport}
                >
                    <div className="leave-approval-maincontainer">
                        <div className="leave-approval-container-part">
                            <div className={`leave-approval-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="leave-approval-container-part">
                            <div className={`leave-approval-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>


                    <div className="leave-approval-maincontainer">
                        <div className="leave-approval-container-part">
                            <div className={`leave-approval-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                                <Select
                                    name="clients"
                                    options={clientResponse}
                                    value={clientResponse.find(opt => opt.value === clients) || null}
                                    onChange={option => handleInputChange(option, 'clients')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Client</label>
                                {errors.clients && <div className="error-message">{errors.clients}</div>}
                            </div>

                        </div>

                        <div className="leave-approval-container-part">
                            <div className={`leave-approval-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>
                                    <span className="required">*</span>Project
                                </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>

                    </div>

                    <div className="leave-approval-maincontainer">
                        <div className="leave-approval-container-part">
                            <div className={`leave-approval-floating-label-container ${isFocused.employee || employee ? 'float-label' : ''}`}>
                                <Select
                                    name="employee"
                                    options={employeeOptions}
                                    value={employeeOptions.find(opt => opt.value === employee) || null}
                                    onChange={option => handleInputChange(option, 'employee')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, employee: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, employee: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>Employee Name</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="leave-approval-container-part">
                            <div className={`leave-approval-floating-label-container ${isFocused.designation || designation ? 'float-label' : ''}`}>
                                <input
                                    type="text"
                                    name="designation"
                                    value={designation || ""}
                                    onChange={(e) => {
                                        setDesignation(e.target.value);
                                        setErrors(prev => ({ ...prev, designation: null }));
                                    }}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, designation: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, designation: false }))}
                                    placeholder=" "
                                    className="did-floating-input"
                                    readOnly
                                />
                                <label>Designation</label>
                                {errors.designation && <div className="error-message">{errors.designation}</div>}
                            </div>

                        </div>
                    </div>
                    <div className="approval-maincontainer">

                        {/* From Date */}
                        <div className="approval-container-part">
                            <div className={`approval-label-container-2 ${isFocused.fromDate || fromDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={fromDate ? new Date(fromDate) : null}
                                    onChange={(date) => {
                                        if (date) {
                                            const localDate = new Date(date);
                                            localDate.setHours(0, 0, 0, 0);
                                            const formatted = localDate.toLocaleDateString("en-CA");
                                            setFromDate(formatted);
                                        } else {
                                            setFromDate("");
                                        }
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="dd-MM-yyyy"
                                    className="did-floating-input"
                                    onFocus={() => setIsFocused(prev => ({ ...prev, fromDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, fromDate: false }))}
                                    ref={dateInputRef}
                                    // maxDate={toDate ? new Date(toDate) : null} // prevents selecting after "To"
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={35}
                                />
                                <label>
                                    <span className="required">*</span>From Date (DD-MM-YYYY)
                                </label>
                                {errors.fromDate && <div className="error-message">{errors.fromDate}</div>}
                            </div>
                        </div>

                        {/* To Date */}
                        <div className="approval-container-part">
                            <div className={`approval-label-container-2 ${isFocused.toDate || toDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={toDate ? new Date(toDate) : null}
                                    onChange={(date) => {
                                        if (date) {
                                            const localDate = new Date(date);
                                            localDate.setHours(0, 0, 0, 0);
                                            const formatted = localDate.toLocaleDateString("en-CA");
                                            setToDate(formatted);
                                        } else {
                                            setToDate("");
                                        }
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="dd-MM-yyyy"
                                    className="did-floating-input"
                                    onFocus={() => setIsFocused(prev => ({ ...prev, toDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, toDate: false }))}
                                    ref={dateInputRef}
                                    // minDate={fromDate ? new Date(fromDate) : null} // prevents selecting before "From"
                                    // maxDate={new Date()}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={35}
                                />
                                <label>
                                    <span className="required">*</span>To Date (DD-MM-YYYY)
                                </label>
                                {errors.toDate && <div className="error-message">{errors.toDate}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="leave-approval-btn-div">
                        <button type="submit" className="leave-approval-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Fetch Data
                        </button>
                    </div>
                </form>
            </div>

            <div className="approval-table-container">
                <table className="approval-table">
                    <thead>
                        <tr>
                            {/* <th>Employee Number</th> */}
                            <th>S.No</th>
                            <th>District Name</th>
                            <th>Employee Name</th>


                            <th>Designation</th>
                            <th>Client</th>
                            <th>Project</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Days Applied</th>
                            <th>Leave Type</th>
                            <th>Reason</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attendanceData.length > 0 ? (
                            attendanceData.map((item,index) => (
                                <tr key={item.id}>
                                    <td>{index+1}</td>
                                    {/* <td>{item.employeeId}</td> */}
                                    <td>{item.district}</td>
                                    <td>{item.employeeName}</td>


                                    <td>{item.designation}</td>
                                    <td>{item.clientName}</td>
                                    <td>{item.projectName}</td>
                                    <td>{item.fromDate.split("-").reverse().join("-")}</td>
                                    <td>{item.toDate.split("-").reverse().join("-")}</td>

                                    <td>{item.daysApplied}</td>
                                    <td>{item.type}</td>
                                    <td>{item.reason}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" style={{ textAlign: "center" }}>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default LeaveApprovalList;